/**
 ** Replaces old labels in the saved floorplan object with new ones.
 ** This process is unfortunately necessary to keep older projects compatible with wording changes.
 **/
export const fixRoomProperties = (room: {
    roomType?: string;
    roomExistingFloorType?: string;
    roomHeatingType?: string;
}) => {
    const toUndefinedIfDefault = (value: string = '') => (value === 'default' ? undefined : value);

    //!\\ roomType
    if (room.roomType === 'Terrasse ou balcon sous abri') {
        room.roomType = 'Terrasse sous abri';
    }
    if (room.roomType === 'Terrasse ou balcon non couverte') {
        room.roomType = 'Terrasse non couverte';
    }

    //!\\ roomExistingFloorType
    if (room.roomExistingFloorType === 'Revêtement plastique (vinyle, lino, dalle)') {
        room.roomExistingFloorType = 'Plastique (vinyle, lino, dalle, gazon)';
    }
    if (room.roomHeatingType === 'Je ne connais pas le type de chauffage') {
        room.roomHeatingType = 'Je ne connais pas le type de chauffage au sol';
    }
    if (room.roomExistingFloorType === 'Placo / Platre / Ciment') {
        room.roomExistingFloorType = 'Placo / Plâtre / Ciment';
    }
    if (room.roomExistingFloorType === 'Beton') {
        room.roomExistingFloorType = 'Béton';
    }

    room.roomExistingFloorType = toUndefinedIfDefault(room['roomExistingFloorType']);
};
